import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { GetTenantResponse } from "@microsearch/g4api-support";

import { session, showError } from "../..";
import { TenantPageLayout } from "../TenantPageLayout/TenantPageLayout";
import { RolesList } from "../../components/RolesList";

type G4Tenant = GetTenantResponse;

export const TenantRolesPage = () => {
  const { tid } = useParams<{ tid: string }>();
  const [tenant, setTenant] = useState<G4Tenant | null>(null);

  useEffect(() => {
    (async () => {
      try {
        setTenant(await (await session.tenant.get(+(tid as string))).data);
      } catch (error) {
        if (error instanceof Error) showError(error.message);
      }
    })();
  }, [tid]);

  return (
    <>
      {tenant && (
        <TenantPageLayout tenant={tenant} selector="roles">
          <RolesList tenant={tenant} />
        </TenantPageLayout>
      )}
    </>
  );
};
